import ecomBoxes from '../assets/ecomBoxes.json';
import creativeDrawAnim from '../assets/creativedraw.json';
import marketingAnim from '../assets/marketing.json';
import digitalServiceAnim from '../assets/platformDevelopment.json';

export type CardStackAnimationKey = 'marketing' | 'digital' | 'ecommerce' | 'creative';

// Single source of truth for stack card animations.
// To swap an animation, only update the import above and this map.
export const CARD_STACK_ANIMATION_BY_KEY: Readonly<
  Record<CardStackAnimationKey, object>
> = Object.freeze({
  marketing: marketingAnim,
  digital: digitalServiceAnim,
  ecommerce: ecomBoxes,
  creative: creativeDrawAnim,
});

export const CARD_STACK_ANIMATION_FALLBACK_KEY: CardStackAnimationKey = 'marketing';

// Legacy fallback for plans that do not set animationKey explicitly.
export const CARD_STACK_KEYWORD_RULES: readonly {
  key: CardStackAnimationKey;
  pattern: RegExp;
}[] = Object.freeze([
  { key: 'ecommerce', pattern: /ecom|commerce|annual|scale/ },
  { key: 'digital', pattern: /digital|quarterly|studio/ },
  { key: 'marketing', pattern: /marketing|monthly/ },
]);
